import { Component, OnInit, ViewEncapsulation, ChangeDetectorRef, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { gettimesheet, employeeFilter, UsedHourDetail, EventEmitterTimesheetBo } from '../timesheet.model';
import { IMyDpOptions } from 'mydatepicker';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DateService } from 'src/app/date.service';
import { EditDetailsAuthorization } from '../../client-parent/client-parent.model';
import { GlobalComponent } from 'src/app/global/global.component';
import { GridComponent, QueryCellInfoEventArgs, ReorderService } from '@syncfusion/ej2-angular-grids';
import { CommonApiService } from 'src/app/commonapiservice';
@Component({
  selector: 'app-timesheet-entry',
  templateUrl: './timesheet-entry.component.html',
  styleUrls: ['./timesheet-entry.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ReorderService],

})
export class TimesheetEntryComponent implements OnInit {
  @Input() EntryInputProperty: EventEmitterTimesheetBo = new EventEmitterTimesheetBo();
  @Output() EntryOutputTimesheet = new EventEmitter<EventEmitterTimesheetBo>();
  private onDestroy$: Subject<void> = new Subject<void>();
  authinput: EditDetailsAuthorization = new EditDetailsAuthorization();
  timesheetclose: boolean = false;
  clientemp: any = [];
  ClientInfoGridList: any = [];
  EmployeeInfoGridList: any = []
  initialPage: object;

  @ViewChild('gridAuthT') public gridAuthT: GridComponent;
  @ViewChild('gridEmployeeList') public gridEmployeeList: GridComponent;
  exceededAuthLimitMessage: any = [];
  gettimesheet: gettimesheet = new gettimesheet();
  public formatOptions: object;
  EditAuthorization: boolean = false;
  start: string;
  end: string;
  Employee: number;
  Client: number;
  isColorEditValue: boolean[] = []
  authorizationdetails: any = [];
  isEnableEnd: boolean = true;
  isEnableservice: boolean = true;
  isEmp: boolean = false;
  isCliInfo: boolean = false;
  umpi: string;
  payorreqID: string;
  EmployeeAka: string;
  serviceName: any = [];
  clientdob: string;
  memberma: string;
  ClientAka: string = "";
  ValidationDate: any;
  services: any = [];
  TimesheetEntryList: any = [];
  isAuthList: boolean = false;
  isNotShowAuth: boolean = false;
  CreateTimesheetEntryList: any = []
  Allhours: string = "";
  enterdhr: number = 0;
  entermin: number = 0;
  pdfSrc: string = "";
  selected: boolean = false;
  filearray: any = [];
  EmployeeId: string;
  editDate: string;
  edittime: string;
  exceededSaveHoursMessage: any = []
  exceededHoursMessage: any = []
  employeeFilter = new employeeFilter();
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 },
    showClearDateBtn: false,
    editableDateField: true
  };
  ClientEmpList: any = [];
  TotalHoursforEmployee: any = null;
  isSaveValidationBoolean: boolean = false;
  ClientNote: any;
  serialNo: number = 0
  ServiceCode: any = [];
  EntryValidationDate: any
  constructor(private ref: ChangeDetectorRef, public dateservice: DateService, public CommonAPI: CommonApiService,
    private cdr: ChangeDetectorRef,
    public global: GlobalComponent,

    public toastrService: ToastrService,
    public datePipe: DatePipe,) {
  }
  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }
  ngOnInit() {
    this.initialPage = {
      pageSizes: ["10", "20", "50", "100", "250"],
      pageSize: 10,
    };
    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
  }
  //.................................................TimesheetEntryDatePickers........................................................
  TimesheetEntryDatePickers(event, type, name) {
    if (type == "inputchanged") {
      if (name == 'start') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.start = val1;
        }
      }
      if (name == 'end') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.end = val1;
        }
      }
      if (name == 'editdate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.editDate = val1;
        }
      }
    }
    if (type == "datachanged") {
      if (name == 'start') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.start = val1;
          var StartDate = new Date(this.start);
          let setDate = StartDate.setDate(StartDate.getDate() + 365);
          let getDate = setDate;
          this.EntryValidationDate = this.datePipe.transform(getDate, "MM/dd/yyyy");
          if (this.start != null && this.start != undefined && this.start != ''
            && this.start != null && this.start != undefined && this.start != '') {
            let EndDate = this.datePipe.transform(this.end, "MM/dd/yyyy");
            if (new Date(EndDate).getTime() > new Date(this.EntryValidationDate).getTime()) {
              this.toastrService.error("Date range should not be greater than 1 year");
              this.end = null;

              setTimeout(() => {
                this.toastrService.clear();
              }, 3000);
              return;
            }
            if (this.end != null && this.end != undefined && this.end != '') {
              if (new Date(this.start).getTime() > new Date(this.end).getTime()) {
                this.end = null;
                this.toastrService.error("end time should greater than start time");
                setTimeout(() => {
                  this.toastrService.clear();
                }, 3000);
                return;
              }
            }
          }
          this.getCurrentMonthHoursOfEmployee(this.Employee);
        }
      }
      if (name == 'end') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.end = val1;
          if (this.start != null && this.start != undefined && this.start != ''
            && this.start != null && this.start != undefined && this.start != '') {
            let EndDate = this.datePipe.transform(this.end, "MM/dd/yyyy");
            if (new Date(EndDate).getTime() > new Date(this.EntryValidationDate).getTime()) {
              this.toastrService.error("Date range should not be greater than 1 year");
              this.end = null;

              setTimeout(() => {
                this.toastrService.clear();
              }, 3000);
              return;
            }
            if (this.end != null && this.end != undefined && this.end != '') {
              if (new Date(this.start).getTime() > new Date(this.end).getTime()) {
                this.end = null;
                this.toastrService.error("end time should greater than start time");
                setTimeout(() => {
                  this.toastrService.clear();
                }, 3000);
                return;
              }
            }
          }
        }
      }
      if (name == 'editdate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.editDate = val1;
        }
      }
    }
  }
  //.................................................showClientDetails........................................................
  showClientDetails(id) {
    this.Employee = null;
    this.Client = id;
    if (id == undefined || id == "undefined" || id == 'undefined') {
      this.isEnableEnd = true;
      this.isEnableservice = true;
      this.start = "";
      this.end = "";
      this.serviceName = "";
    } else {
      this.getClientEmpRelationship(id);
    }
    this.serviceName = "";
    if (new Date(this.start) != undefined && new Date(this.end) != undefined)
      this.startdates(this.start, this.end, id)
    this.Client = id;
    this.ClientInfoGridList = [];
    this.EntryInputProperty.ClientDropDown?.forEach(element => {
      if (element.id == id) {
        this.ClientInfoGridList.push(element)
      }
    });
    this.isCliInfo = true;
  }
  //.................................................showEmployeeDetails........................................................
  showEmployeeDetails(id) {
    if (id == undefined || id == 'undefined' || id == "undefined") {
      this.isEnableEnd = true;
      this.isEnableservice = true;
    } else {
      this.isEnableEnd = false;
      this.isEnableservice = false;
      this.EmployeeInfoGridList = [];
      this.EntryInputProperty.EmployeeDropDown.forEach(element => {
        if (id == element.id) {
          this.EmployeeInfoGridList.push(element)
          this.Employee = id;
        }
      });
      this.getCurrentMonthHoursOfEmployee(id);

      this.showTimesheestoView(this.start, this.end, this.serviceName)
    }
    this.isEmp = true;
    this.Employee = id;
  }
  //.................................................startdates........................................................
  startdates(startdate, enddate, clientsid) {
    if (startdate == undefined || startdate == "undefined" || startdate == 'undefined') {
      this.isEnableEnd = true;
      if (new Date(startdate) == undefined) {
        return;
      }
    } else {
      this.isEnableEnd = false;
    }
    if (enddate == undefined || enddate == "undefined" || enddate == 'undefined') {
      this.isEnableservice = true;
      if (new Date(enddate) == undefined) {
        return;
      }
    } else {
      this.isEnableservice = false;
    }
    startdate = this.datePipe.transform(startdate, 'MM-dd-yyyy');
    enddate = this.datePipe.transform(enddate, 'MM-dd-yyyy');
    if (clientsid == undefined || clientsid == '' || clientsid == "") {
      clientsid = null
    }
    if (startdate != null && enddate != null && clientsid != null) {
      if ((new Date(startdate).getTime() < new Date(enddate).getTime()) || (startdate == enddate)) {
        let parameter = new URLSearchParams();
        parameter.append("startdate", startdate)
        parameter.append("enddate", enddate)
        parameter.append("clientid", clientsid)
        let url = "api/Timesheet/FilteracctoStartdate?";
        this.CommonAPI.GetFunctionwithResponseTypeJson(parameter, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
          let i;
          this.serviceName = "";
          this.TimesheetEntryList = [];
          let service = [];
          data?.forEach(element => {
            if (element.remaingHours <= 100) {
              element.isColorEditValue = true;
            }
            else {
              element.isColorEditValue = false;
            }
          });
          if (data?.length != 0) {
            for (i = 0; i < data?.length; i++) {
              data[i].Value = data[i].masterServiceCode + "," + data[i].serviceDesc;
              data[i].Key = data[i].id.toString();
              service[i] = { value: data[i].masterServiceCode, label: data[i].masterServiceCode, key: data[i].masterServiceId };
              let hrMinStr = data[i].hoursPerDay.toString().split('.');
              if (hrMinStr?.length == 1) {
                data[i].hoursPerDay = hrMinStr[0] + " hr " + "0 Min";
              }
              else {
                let minStr = 0 + "." + hrMinStr[hrMinStr.length - 1];
                data[i].hoursPerDay = hrMinStr[0] + " hr " + (parseFloat(minStr) * 60).toString().split('.')[0] + "Min";
              }
              let hoursPerDayBasedOnLastVisitDateString = data[i].hoursPerDayBasedOnLastVisitDate?.toString().split('.');
              if (hoursPerDayBasedOnLastVisitDateString?.length == 1) {
                data[i].hoursPerDayBasedOnLastVisitDate = hoursPerDayBasedOnLastVisitDateString[0] + " hr " + "0 Min";
              }
              else {
                let minStr = 0 + "." + hoursPerDayBasedOnLastVisitDateString[hoursPerDayBasedOnLastVisitDateString.length - 1];
                data[i].hoursPerDayBasedOnLastVisitDate = hoursPerDayBasedOnLastVisitDateString[0] + " hr " + (parseFloat(minStr) * 60).toString().split('.')[0] + "Min";
              }
              if (data[i].remaingHours <= 100) {
                this.isColorEditValue[i] = true;
              }
              else {
                this.isColorEditValue[i] = false;
              }
              let hrMinStr1 = data[i].remaingHours.toString().split('.');
              if (hrMinStr1?.length == 1) {
                data[i].remaingHours = hrMinStr1[0] + " hr " + "0 Min";

              }
              else {
                let minStr1 = 0 + "." + hrMinStr1[hrMinStr1.length - 1];
                data[i].remaingHours = hrMinStr1[0] + " hr " + (parseFloat(minStr1) * 60).toString().split('.')[0] + "Min";
              }
              let hrperWeekMinStr = data[i].hoursPerWeek.toString().split('.');
              if (hrperWeekMinStr?.length == 1) {
                data[i].hoursPerWeek = hrperWeekMinStr[0] + " hr " + "0 Min";
              }
              else {
                let minStr = 0 + "." + hrperWeekMinStr[hrperWeekMinStr.length - 1];
                data[i].hoursPerWeek = hrperWeekMinStr[0] + " hr " + (parseFloat(minStr) * 60).toString().split('.')[0] + "Min";
              }
            }
          }
          this.authorizationdetails = data;
         
          if (this.authorizationdetails?.length == 0) {
            this.isNotShowAuth = true;
            this.isAuthList = false;
          }
          else {
            this.isNotShowAuth = false;
            this.isAuthList = true;
          }
        })
      }
    }
  }

  //.................................................checktimesheet........................................................
  checktimesheet(startDate, endDate, serviceName) {
    this.services = [];
    this.serviceName?.forEach(element => {
      let services = this.authorizationdetails?.filter(a => a.id == element)[0];
     
      this.services.push(services.masterserviceId)
    });
   
    return new Promise((resolve, reject) => {
      let param = new URLSearchParams();
      param.append("employee", this.Employee.toString())
      param.append("client", this.Client.toString())
      param.append("startdate", startDate)
      param.append("enddate", endDate)
      param.append("service", this.services)
      param.append("clientAuthorization", serviceName)
      let url = "api/timesheet/checktimesheet?"
      this.CommonAPI.GetFunctionwithResponseTypeJson(param, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        resolve(data)
      }, (err) => {
        reject(err)
      });
    });
  }
  //.................................................show........................................................
  async showTimesheestoView(startDate, endDate, serviceName) {
    
    this.enterdhr = 0;
    this.entermin = 0;
    this.Allhours = "";
    if ((new Date(startDate).getTime() < new Date(endDate).getTime()) || (startDate == endDate)) {
      this.TimesheetEntryList = [];
      var timesheetdata: any = []
      if (serviceName != null && serviceName != '' && serviceName != undefined && serviceName != "") {
        timesheetdata = await this.checktimesheet(startDate, endDate, serviceName).then((res: any) => { return res });
      }
      var startDate1 = new Date(startDate);
      var endDate1 = new Date(endDate);
      var daysdiff = Math.floor((Date.UTC(endDate1.getFullYear(), endDate1.getMonth(), endDate1.getDate()) -
        Date.UTC(startDate1.getFullYear(), startDate1.getMonth(), startDate1.getDate())) / (1000 * 60 * 60 * 24));
      for (let ss: number = 0; ss < this.serviceName.length; ss++) {
        for (let i: number = 0; i <= daysdiff; i++) {
          var d2 = new Date(startDate1)
          d2.setDate(d2.getDate() + i)
          let cormdata = false;
          let S0215HoursremoveValidation = false;
          let total = "";
          let timesheetnotes = "";
          let timesheetid = 0;
          let etimesheet = "";
          if (timesheetdata.length != 0) {
            timesheetdata.forEach(element => {
              let today = this.datePipe.transform(element.date, 'MM/dd/yyyy');
              if (today == this.datePipe.transform(d2, 'MM/dd/yyyy') && element.employee == parseInt(this.Employee.toString()) && element.client == parseInt(this.Client.toString())
                && parseInt(this.authorizationdetails?.filter(s => s.Key == serviceName[ss])[0]?.masterserviceId) == element.service) {
                cormdata = true;
                total = element.totalhour != null ? element.totalhour : "";
                timesheetnotes = element.notes != null ? element.notes : "";
                timesheetid = element.id;
                etimesheet = element.etimesheet == true ? "Yes" : "No";
              }
            });
          }
          else {
            total = "";
            timesheetnotes = "";
          }
          var d1: any = new Date(d2).getDay()
          switch (d1) {
            case 0:
              d1 = "Sunday";
              break;
            case 1:
              d1 = "Monday";
              break;
            case 2:
              d1 = "Tuesday";
              break;
            case 3:
              d1 = "Wednesday";
              break;
            case 4:
              d1 = "Thursday";
              break;
            case 5:
              d1 = "Friday";
              break;
            case 6:
              d1 = "Saturday";
          }

          let serviceHoursValidation = this.authorizationdetails?.filter(s => s.Key == serviceName[ss])[0]?.Value;
        
          if (serviceHoursValidation.indexOf('S0215') > -1) {
            S0215HoursremoveValidation = true;
          }
          this.CreateTimesheetEntryList = {
            Id: timesheetid != 0 ? timesheetid : 0,
            Day: d1,
            Date: (new Date(d2).getMonth() + 1) + '/' + new Date(d2).getDate() + '/' + new Date(d2).getFullYear(),
            service: this.authorizationdetails.filter(s => s.Key == serviceName[ss])[0]?.Value,
            tcHours: total != "" ? total : "",
            notes: timesheetnotes != "" ? timesheetnotes : "",
            isDisable: cormdata,
            isRemoveS0215HoursValidation: S0215HoursremoveValidation,
            etimesheet: etimesheet
          }
          this.TimesheetEntryList.sort((sort1, sort2) => +new Date(sort1.Date) - +new Date(sort2.Date));
          this.TimesheetEntryList.push(this.CreateTimesheetEntryList);
        }
      }
    }

    if (this.TimesheetEntryList.length > 0) {
      this.calculatehours(this.TimesheetEntryList)
    }
  }
  //.................................................numbersOnlyS2015Validation........................................................
  numbersOnlyS2015Validation(event: any, type) {
    this.ref.detach();
    setInterval(() => {
      this.ref.detectChanges();
    }, 10);
    if (((event.which < 48 && (event.which != 8 && event.which != 46 && event.which != 39 && event.which != 37)) || event.which > 57) && ((event.which < 96 && (event.which != 8 && event.which != 46 && event.which != 39 && event.which != 37)) || event.which > 105)) {
      event.preventDefault();
    }
    let txt = "";
    if (type == "create") {
      txt = event.target.innerHTML;
    }
    if (type == "update") {
      txt = this.edittime;
    }
    if (type == "All") {
      txt = this.Allhours;
    }
    txt = (txt.trim) ? txt.trim() : txt.replace(/^\s+/, '');
    // length 1
    if (txt.length == 1) {
      if (txt == "10") {

        if (event.key > 3) {

          event.preventDefault();
        }

      }

      if (parseInt(txt) > 9) {

        if (event.which != 50) {
          event.preventDefault();
        }
      }
      if (txt == '.') {
        if (!(event.which == 50 || event.which == 53 || event.which == 55 || event.which == 48)) {
          event.preventDefault();
        }
      }


    }
    //  length 2
    if (txt.length == 2) {
      let tempdata = txt.split("");
      if (!(tempdata[1] == ".")) {
        if (tempdata[0] == ".") {

          if (tempdata[1] == "5" || tempdata[1] == "0") {

            if (!(event.which == 48)) {


              event.preventDefault();
            }
          }
          if (tempdata[1] == "2" || tempdata[1] == "9") {

            if (!(event.which == 53)) {


              event.preventDefault();
            }
          }
        }
        else if (event.which != 46) {
          event.preventDefault();
        }
      }
      else {

        if (!(event.which == 50 || event.which == 53 || event.which == 55 || event.which == 48)) {
          event.preventDefault();
        }
      }
    }
    // length 3
    if (txt.length == 3) {
      let tempdata = txt.split("");
      if (tempdata[0] == ".") {
        event.preventDefault();
      }
      if (tempdata[2] == ".") {

        if (!(event.which == 50 || event.which == 53 || event.which == 55 || event.which == 48)) {


          event.preventDefault();
        }

      }
      if (tempdata[1] == ".") {

        let tempdata1 = txt.split(".");

        if (tempdata1[1] == "5" || tempdata1[1] == "0") {

          if (!(event.which == 48)) {


            event.preventDefault();
          }
        }
        if (tempdata1[1] == "2" || tempdata1[1] == "7") {

          if (!(event.which == 53)) {


            event.preventDefault();
          }
        }
      }
    }
    // length 4
    if (txt.length == 4) {
      let tempdata = txt.split(".");
      if (tempdata[1].length == 2) {
        event.preventDefault();
      }
      if (tempdata[1] == "5" || tempdata[1] == "0") {

        if (!(event.which == 48)) {


          event.preventDefault();
        }
      }
      if (tempdata[1] == "2" || tempdata[1] == "7") {

        if (!(event.which == 53)) {


          event.preventDefault();
        }
      }
    }
    if (txt.length > 4) {
      event.preventDefault();
    }
  }
  //.................................................numberonly........................................................
  numberonly(event: any, type) {
    this.ref.detach();
    setInterval(() => {
      this.ref.detectChanges();
    }, 10);
    if (((event.which < 48 && (event.which != 8 && event.which != 46 && event.which != 39 && event.which != 37)) || event.which > 57) && ((event.which < 96 && (event.which != 8 && event.which != 46 && event.which != 39 && event.which != 37)) || event.which > 105)) {
      event.preventDefault();
    }
    let txt = "";
    if (type == "create") {
      txt = event.target.innerHTML;
    }
    if (type == "update") {
      txt = this.edittime;
    }
    if (type == "All") {
      txt = this.Allhours;
    }
    txt = (txt.trim) ? txt.trim() : txt.replace(/^\s+/, '');
    if (txt.length == 1) {
      if (txt == "2") {
        if (event.key > 4) {

          event.preventDefault();
        }

      }
      if (parseInt(txt) > 2) {
        if (event.which != 46) {
          event.preventDefault();
        }
      }
      if (txt == '.') {
        if (!(event.which == 50 || event.which == 53 || event.which == 55 || event.which == 48)) {
          event.preventDefault();
        }
      }


    }
    if (txt.length == 2) {
      if (txt == '24') {
        event.preventDefault();
      }
      else {
        let tempdata = txt.split("");
        if (!(tempdata[1] == ".")) {
          if (tempdata[0] == ".") {

            if (tempdata[1] == "5" || tempdata[1] == "0") {

              if (!(event.which == 48)) {


                event.preventDefault();
              }
            }
            if (tempdata[1] == "2" || tempdata[1] == "7") {

              if (!(event.which == 53)) {


                event.preventDefault();
              }
            }
          }
          else if (event.which != 46) {
            event.preventDefault();
          }

        }
        else {

          if (!(event.which == 50 || event.which == 53 || event.which == 55 || event.which == 48)) {
            event.preventDefault();
          }
        }
      }
    }
    if (txt.length == 3) {

      let tempdata = txt.split("");

      if (tempdata[0] == ".") {
        event.preventDefault();
      }
      if (tempdata[2] == ".") {

        if (!(event.which == 50 || event.which == 53 || event.which == 55 || event.which == 48)) {


          event.preventDefault();
        }

      }
      if (tempdata[1] == ".") {

        let tempdata1 = txt.split(".");

        if (tempdata1[1] == "5" || tempdata1[1] == "0") {

          if (!(event.which == 48)) {


            event.preventDefault();
          }
        }
        if (tempdata1[1] == "2" || tempdata1[1] == "7") {

          if (!(event.which == 53)) {


            event.preventDefault();
          }
        }
      }
    }
    if (txt.length == 4) {
      let tempdata = txt.split(".");

      if (tempdata[1].length == 2) {
        event.preventDefault();
      }

      if (tempdata[1] == "5" || tempdata[1] == "0") {

        if (!(event.which == 48)) {


          event.preventDefault();
        }
      }
      if (tempdata[1] == "2" || tempdata[1] == "7") {

        if (!(event.which == 53)) {


          event.preventDefault();
        }
      }
    }
    if (txt.length > 4) {
      event.preventDefault();
    }
  }
  //.................................................AddHoursForBulkTimsheets........................................................
  AddHoursForBulkTimsheets() {
    this.TimesheetEntryList.forEach((element, index) => {
      if (element.etimesheet != "Yes") {
        let txt = document.getElementById("editable_div" + index);
        txt.innerHTML = this.Allhours;
        element.tcHours = "";
        element.tcHours = this.Allhours;
      }
    });
    this.calculatehours(this.TimesheetEntryList)
  }
  //.................................................calculatehours........................................................
  calculatehours(TimesheetEntryList) {
    let totalhours: any;
    TimesheetEntryList.forEach(element => {
      if (element.tcHours != null && element.tcHours != '') {
        totalhours = TimesheetEntryList.filter(t => t.tcHours != null && t.tcHours != undefined && t.tcHours != "" && t.tcHours != '.').map(t => t.tcHours)?.reduce((sum, sum1) => {
          return parseFloat(sum) + parseFloat(sum1)
        })
      }
    });
    if (totalhours != undefined && totalhours != null && totalhours != '') {
      let val5 = ((totalhours).toString()).split('.');
      if (val5.length == 2) {
        if (val5[val5.length - 1].length == 1) {
          val5[val5.length - 1] = parseInt(val5[val5.length - 1]) * 10;
        }
        if (parseFloat(0 + "." + val5[val5.length - 1]) == 0.25) {

          this.enterdhr = val5[0];
          this.entermin = 15;

        }
        if (parseFloat(0 + "." + val5[val5.length - 1]) == 0.50) {

          this.enterdhr = val5[0];
          this.entermin = 30;

        }
        if (parseFloat(0 + "." + val5[val5.length - 1]) == 0.75) {

          this.enterdhr = val5[0];
          this.entermin = 45;

        }
      }
      else {
        this.enterdhr = val5[0];
        this.entermin = 0;
      }
    }
  }
  //.................................................saveHours........................................................
  saveHours(event, i) {
    if (event.target.innerHTML == "") {
      this.TimesheetEntryList[i].tcHours = 0;
    }
    else {
      if (event.target.innerHTML == "") {
        this.TimesheetEntryList[i].tcHours = 0;
      }
      else { this.TimesheetEntryList[i].tcHours = event.target.innerHTML.replace(/\s/g, ""); }
      this.TimesheetEntryList[i].tcHours = event.target.innerHTML.toString().replace(/\s/g, "");
      event.target.innerHTML = this.TimesheetEntryList[i].tcHours;
      this.calculatehours(this.TimesheetEntryList);
    }
    return true;
  }
  //.................................................saveNotes........................................................
  saveNotes(event, i) {
    this.TimesheetEntryList[i].notes = event.target.innerText;
  }
  //.................................................onFileChanged........................................................
  async onFileChanged(event) {
    let i = 0;
    for (i = 0; i < event.target.files.length; i++) {
      let val = await this.tobase64(event.target.files[i]);
      this.selected = true;
      this.filearray[i] = { "TimesheetUploadName": event.target.files[i].name, "uploadtimesheet": val }
    }
    this.pdfSrc = this.filearray[0].uploadtimesheet;
  }
  //.................................................tobase64........................................................
  tobase64 = value => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(value);
    reader.onload = (e: any) => resolve(e.target.result);
    reader.onerror = error => reject(error);
  });
  //.................................................exceedSaveNewHoursList........................................................
  exceedSaveNewHoursList(saveList) {
    var exceededHours = this.validateHoursExceeded(saveList);
    if (exceededHours.length > 0) {
      this.exceededHoursMessage = exceededHours
      document.getElementById("openNewModalAlert").click();
      return;
    }
    else {
      this.saveNewTimesheetList(saveList);
    }
  }
  //.................................................saveNewTimesheetList........................................................
  saveNewTimesheetList(saveNewList) {
    let list = JSON.parse(JSON.stringify(saveNewList))
    let checkempty = 0;
    list.forEach(element => {
      if (element.tcHours == 0 || element.tcHours == "" || element.tcHours == null) {
        checkempty = checkempty + 1;
      }
    });
    if (checkempty == list.length) {
      this.toastrService.error(
        "Please enter Total Hours",
        "error",
      );
      return;
    }
    let FirstValue;
    let TempFirst: any = [];
    let TempSecond: any = [];
    let TempFinalArray: any = [];

    if (this.serviceName.length > 1) {
      this.serviceName.forEach(s => {
        let val = {};
        let serviceid = this.authorizationdetails?.filter(d => d.Key == parseInt(s))[0].Value;
        if (this.authorizationdetails.length != 0) {
          if (this.authorizationdetails.filter(d => d.masterServiceCode == serviceid).length != 0) {
            val = {
              clientautherizationId: this.authorizationdetails.filter(d => d.masterServiceCode == serviceid)[0].id,
              serviceId: parseInt(s)
            }
          }
          else {
            val = { clientautherizationId: 0, serviceId: 0 };
          }
        }
        else {
          val = { clientautherizationId: 0, serviceId: 0 };
        }
        TempSecond.push(val);
      });
    }
    else {
      let serviceid = this.authorizationdetails?.filter(d => d.Key == parseInt(this.serviceName[0]))[0].Value;
      if (this.authorizationdetails.length != 0) {
        if (this.authorizationdetails[0].masterServiceCode == serviceid) {
          TempSecond = [{
            clientautherizationId: this.authorizationdetails.filter(d => d.masterServiceCode == serviceid)[0].id,
            serviceId: parseInt(this.authorizationdetails?.filter(d => d.Value == serviceid)[0].Key),
          }]
        } else {
          TempSecond = [{ clientautherizationId: 0, serviceId: 0 }];
        }
      } else {
        TempSecond = [{ clientautherizationId: 0, serviceId: 0 }];
      }
    }
    let SecondValue = 0;
    for (FirstValue = 0; FirstValue < list.length; FirstValue++) {
      let dataList = 0;
      dataList = this.authorizationdetails?.filter(s => s.Value == list[FirstValue].service)[0].Key
      if (!(list[FirstValue].tcHours == "" || list[FirstValue].tcHours == 0)) {
        dataList = this.authorizationdetails?.filter(s => s.Value == list[FirstValue].service)[0].Key
        if (!(list[FirstValue].tcHours == "" || list[FirstValue].tcHours == 0)) {
          let val1 = (list[FirstValue].tcHours.toString()).replace(/\s/g, "");
          TempFirst[SecondValue] = {
            Id: list[FirstValue].Id,
            EmployeeId: parseInt(this.Employee.toString()),
            ClientId: parseInt(this.Client.toString()),
            MasterServiceId:  this.authorizationdetails?.filter(a => a.id == dataList)[0]?.masterserviceId,
            authorizationId:parseInt(dataList.toString()),
            TimesheetDate: (new Date(new Date(list[FirstValue].Date).toDateString() + " "
              + "00:00:000" + " " + "GMT").toISOString()).replace("Z", ""),
            TimesheetNotes: list[FirstValue].notes,
            GroupPayorServiceId: this.authorizationdetails.filter(s => s.masterServiceCode == list[FirstValue].service).length != 0 ? this.authorizationdetails.filter(s => s.masterServiceCode == list[FirstValue].service)[0].groupPayorServiceId : null,
            TotalHours: parseFloat(val1),
            isCliSignature: true,
            isEmpSignature: true,
          }
          SecondValue++;
        }
      }
    }
   
    TempFinalArray = {
      timesheet: TempFirst,
      clientauth: TempSecond,
      file: this.filearray
    }

   
    // let url = "api/Timesheet/SaveTimesheet"
    let url = "api/Timesheet/SaveTimesheetWithAuthorization"
   
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(TempFinalArray, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data.length > 0) {
        this.toastrService.error(data, 'Error'), 4000;
        return;
      }
      this.TimesheetEntryList = "";
      this.Allhours = "";
      this.TimesheetEntryList = [];
      this.Client = 0;
      this.Employee = 0;
      this.start = this.start;
      this.end = this.end;
      this.timesheetclose = false;
      this.serviceName = '';
      this.authorizationdetails = [];
      this.isEmp = false;
      this.isCliInfo = false;
      this.isAuthList = false;
      this.isNotShowAuth = false;
      this.selected = false;
      this.enterdhr = 0;
      this.entermin = 0;
      this.toastrService.success(
        'Timesheets created successfully!'), 8000;
      this.isEnableEnd = true;
      this.isEnableservice = true;
    },
      (err: any) => {
        this.toastrService.error(
          err,
          "error",
        );
        setTimeout(() => {
          this.toastrService.clear()
        }, 8000);
      })
  }
  //.................................................exceedSaveHoursList........................................................
  exceedSaveHoursList(saveExceedList) {
    var exceededData = this.validateHoursExceeded(saveExceedList);
    if (exceededData.length > 0) {
      this.exceededSaveHoursMessage = exceededData
      document.getElementById("openSaveModalAlert").click();
      return;
    }
    else {
      this.saveTimesheetList(saveExceedList)
    }
  }
  //.................................................saveTimesheetList........................................................
  saveTimesheetList(saveTimesheet) {
    let list = JSON.parse(JSON.stringify(saveTimesheet))
    let checkempty = 0
    let i;
    let temp: any = [];
    let temp1: any = [];
    let temparray: any = [];
    list.forEach(element => {
      if (element.tcHours == 0 || element.tcHours == "" || element.tcHours == null) {
        checkempty = checkempty + 1;
      }
    });
    if (checkempty == list.length) {
      this.toastrService.error(
        "Please enter Total Hours",
        "error",
      );
      return
    }
    if (this.serviceName.length > 1) {
      this.serviceName.forEach(s => {
        let val = {};
        let serviceid = this.authorizationdetails?.filter(d => d.Key == parseInt(s))[0].Value;
        if (this.authorizationdetails.length != 0) {

          if (this.authorizationdetails.filter(d => d.masterServiceCode == serviceid).length != 0) {

            val = {
              clientautherizationId: this.authorizationdetails.filter(d => d.masterServiceCode == serviceid)[0].id,
              serviceId: parseInt(s)
            }

          }
          else {
            val = { clientautherizationId: 0, serviceId: 0 };
          }
        }
        else {
          val = { clientautherizationId: 0, serviceId: 0 };
        }
        temp1.push(val);
      });
    }
    else {
      let serviceid = this.authorizationdetails?.filter(d => d.Key == parseInt(this.serviceName[0]))[0].Value;
      if (this.authorizationdetails.length != 0) {
        if (this.authorizationdetails[0].masterServiceCode == serviceid) {
          temp1 = [{
            clientautherizationId: this.authorizationdetails.filter(d => d.masterServiceCode == serviceid)[0].id,
            serviceId: parseInt(this.authorizationdetails?.filter(d => d.Value == serviceid)[0].Key),
          }]
        } else {
          temp1 = [{ clientautherizationId: 0, serviceId: 0 }];
        }
      } else {
        temp1 = [{ clientautherizationId: 0, serviceId: 0 }];
      }
    }
    let j = 0;
    for (i = 0; i < list.length; i++) {
      let datas = 0;
      datas = this.authorizationdetails?.filter(s => s.Value == list[i].service)[0].Key
      if (!(list[i].tcHours == "" || list[i].tcHours == 0)) {
        datas = this.authorizationdetails?.filter(s => s.Value == list[i].service)[0].Key;
        if (!(list[i].tcHours == "" || list[i].tcHours == 0)) {
          let val1 = (list[i].tcHours.toString()).replace(/\s/g, "");
          temp[j] = {
            Id: list[i].Id,
            EmployeeId: parseInt(this.Employee.toString()),
            ClientId: parseInt(this.Client.toString()),
            MasterServiceId:  this.authorizationdetails?.filter(a => a.id == datas)[0]?.masterserviceId,
            authorizationId:parseInt(datas.toString()),
            TimesheetDate: (new Date(new Date(list[i].Date).toDateString() + " "
              + "00:00:000" + " " + "GMT").toISOString()).replace("Z", ""),
            TimesheetNotes: list[i].notes,
            GroupPayorServiceId: this.authorizationdetails.filter(s => s.masterServiceCode == list[i].service).length != 0 ? this.authorizationdetails.filter(s => s.masterServiceCode == list[i].service)[0].groupPayorServiceId : null,
            TotalHours: parseFloat(val1),
            isCliSignature: true,
            isEmpSignature: true,
          }
          j++;
        }
      }
    }
    
    temparray = {
      timesheet: temp,
      clientauth: temp1,
      file: this.filearray
    }

  
    // let url = "api/Timesheet/SaveTimesheet"
    let url = "api/Timesheet/SaveTimesheetWithAuthorization"

   

    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(temparray, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      if (data.length > 0) {
        this.toastrService.error(data, 'Error'), 4000;
        return;
      }
      this.filearray = [];
      this.toastrService.success(
        'Timesheets created successfully!',
      ), 3000;
      this.timesheetclose = false;
      this.isSaveValidationBoolean = false;
      this.backtoTimesheetView();
    },
      (err: any) => {
        this.isSaveValidationBoolean = false;
        this.toastrService.error(
          err,
          "error",
        );
        setTimeout(() => {
          this.toastrService.clear()
        }, 8000);

      })
  }
  //.................................................validateHoursExceeded........................................................
  validateHoursExceeded(validateExceedList): string[] {
    let errorMessages: string[] = [];
    let timesheets = JSON.parse(JSON.stringify(validateExceedList));
    let usedHourDetails = [];
    
    this.serviceName.forEach(authId => {
      let usedHourDetail = new UsedHourDetail();
      usedHourDetail.serviceId = this.authorizationdetails?.filter(ad => ad.id == authId)[0].masterserviceId;
      usedHourDetail.serviceCode = this.authorizationdetails?.filter(sd => sd.Key == authId).map(sd => sd.Value)[0];
      usedHourDetail.hoursUsed = timesheets?.filter(ts => ts.service == usedHourDetail.serviceCode).filter(ts => ts.Id == 0).reduce((sum, ts) => sum + parseInt(ts.tcHours), 0);
      usedHourDetails.push(usedHourDetail);
    });
    usedHourDetails.forEach(usedHourDetail => {
      var authorization = this.authorizationdetails.filter(ad => ad.masterserviceId == usedHourDetail.serviceId)[0];
      if (authorization == null) {
        errorMessages.push("No Authorization found for " + usedHourDetail.serviceCode)
      }
      else if (authorization.hoursRemaining < usedHourDetail.hoursUsed) {
        errorMessages.push((usedHourDetail.hoursUsed - authorization.hoursRemaining) + " hrs exceeded for " + usedHourDetail.serviceCode);
      }
    });
    return errorMessages;
  }
  //.................................................dataEmitfromChild........................................................
  dataEmitfromChild(event: EditDetailsAuthorization) {
    this.EditAuthorization = false;
    this.authinput.isEdit = false;
    this.authinput.isView = true;
    this.authinput = event
    this.startdates(this.start, this.end, this.Client)
  }
  //.................................................AddClientAuthorization........................................................
  AddClientAuthorization() {

    this.authinput.ClientId = (this.Client.toString());
    this.authinput.isEdit = true;
    this.authinput.type = "new";
    this.authinput.isEditAuthorization = true;
    this.authinput.isView = false;
    this.EditAuthorization = true;

  }
  //.................................................backwithalert........................................................
  backwithalert() {
    this.backtoTimesheetView()
  }
  //.................................................selectSpecifyService........................................................
  selectSpecifyService(val, authorizationdetails) {
    //   var exceededHours:any[] = this.validateExceedingAuthLimit(val,authorizationdetails);
    //   if(exceededHours!=null && exceededHours!=undefined )
    //   {
    //   if (exceededHours.length > 0) {
    //     this.exceededAuthLimitMessage = exceededHours
    //     document.getElementById("openExceedingAuthLimitModalAlert").click();
    //     return;
    //   }
    // }
    let hrMinStr = [];
    if (this.serviceName.length == 0 || this.serviceName == '' || this.serviceName == null || this.serviceName == undefined) {
      this.serviceName = []
      let val1 = val.toString()
      hrMinStr = this.serviceName;
      hrMinStr.push(val1);
    }
    else {
      let val3 = this.serviceName.filter(s => s == val.toString())
      if (val3.length == 0) {
        let val1 = val.toString()
        hrMinStr = this.serviceName;
        hrMinStr.push(val1);
      }
      else {
        hrMinStr = this.serviceName;
      }
    }
    this.serviceName = [];
    setTimeout(() => {
      this.serviceName = hrMinStr;
      this.showTimesheestoView(this.start, this.end, this.serviceName)
    }, 100);
    this.timesheetclose = true;
  }

  //.................................................getClientEmpRelationship........................................................
  getClientEmpRelationship(id) {
    this.ClientEmpList = [];
    this.clientemp = [];
    let param = new URLSearchParams();
    param.append("client", id.toString())
    param.append("locationId", this.EntryInputProperty.LocationLid)
    let url = "api/ClientEmployeeRelationship/GetClientEmployeeRelation?";
    this.CommonAPI.GetFunctionwithResponseTypeJson(param, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.ClientEmpList = data;
      this.EntryInputProperty.EmployeeDropDown = this.ClientEmpList.empList;
      this.EntryInputProperty.EmployeeDropDown.forEach(element => {
        element.Key = element.id.toString();
        element.Value = element.names;

      })
      if (this.ClientEmpList.hasRelationship == true) {
        this.Employee = this.EntryInputProperty.EmployeeDropDown[0].Key;
        this.EmployeeInfoGridList = [];
        this.EntryInputProperty.EmployeeDropDown.forEach(element => {
          this.isEmp = true;
          if (element.id == this.Employee) {
            this.EmployeeInfoGridList.push(element)
            this.Employee = id;
            this.Employee = this.EntryInputProperty.EmployeeDropDown[0].Key;

          }
        });
      }
      else {
        this.Employee = 0;
      }

      this.getCurrentMonthHoursOfEmployee(this.Employee);
    });

  }
  //.................................................getCurrentMonthHoursOfEmployee........................................................
  getCurrentMonthHoursOfEmployee(EmpId) {
    if (this.start != null && this.start != undefined && this.start != "") {
      let EmployeeId = (EmpId == 0 || EmpId == undefined || EmpId == '') ? 0 : EmpId;
      let params = new URLSearchParams();
      params.append("employee", EmployeeId);
      params.append("startDate", this.global.getDateTimeString(this.start));
      let url = "api/Timesheet/getCurrentMonthHoursOfEmployee?";
      this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
        this.EmployeeInfoGridList.forEach(Eg => {
          Eg.totalHoursforEmployee = data
        });
        this.gridEmployeeList.refresh();
        if (data != null) {
          this.isEmp = true;
        }
      });
    }
  }
  //................................................backtoTimesheetView................................................................
  backtoTimesheetView() {

    if (this.timesheetclose == true) {
      document.getElementById("OpenWithoutSaveTimesheet").click();
    }
    else {
      this.EntryInputProperty.isEntry = null;
      this.EntryOutputTimesheet.emit(this.EntryInputProperty);
    }
  }
  //................................................validateClientInformationbutton................................................................
  validateClientInformationbutton(args: QueryCellInfoEventArgs) {
    if (args.column.field === 'aka') {
      if (args.data[args.column.field] != undefined && args.data[args.column.field] != null) {
        args.cell.classList.add('aka');
      }
    }
  }
  //................................................validateEmployeeInformationbutton................................................................
  validateEmployeeInformationbutton(args: QueryCellInfoEventArgs) {
    if (args.column.field === 'aka') {
      if (args.data[args.column.field] != undefined && args.data[args.column.field] != null) {
        args.cell.classList.add('aka');
      }
    }
  }
  //................................................validateAuthorizationDetailsbutton................................................................
  validateAuthorizationDetailsbutton(args: QueryCellInfoEventArgs) {
    if (args.column.field === 'remaingHours') {
      if (args.data['isColorEditValue'] == true) {
        args.cell.classList.add('aka');
      }
    }
  }
  //................................................validateExceedingAuthLimit................................................................
  validateExceedingAuthLimit(id, authorizationdetails): string[] {

    let errorMessages = [];
    if (authorizationdetails.authLimitType == "Weekly") {
      var StartDate = new Date(authorizationdetails.authLimitStartDate);
      let setDate = StartDate.setDate(StartDate.getDate() + 6);
      let getDate = setDate;
      let authLimitEndDate = this.datePipe.transform(getDate, "MM/dd/yyyy");
      authLimitEndDate = this.global.getDateTimeString(authLimitEndDate);

      if (new Date(authorizationdetails.authLimitStartDate).getTime() > new Date(this.start).getTime()
      ) {

        errorMessages.push(authorizationdetails.masterServiceCode + " " + authorizationdetails.serviceDesc);
      }
      else {
      }
    }
    if (authorizationdetails.authLimitType == "Monthly") {
      let currentMonth = new Date().getMonth() + 1;
      let startDateMonth = new Date(this.start).getMonth() + 1
      let endDateMonth = new Date(this.end).getMonth() + 1
      if (currentMonth != startDateMonth || currentMonth != endDateMonth) {
        errorMessages.push(authorizationdetails.masterServiceCode + " " + authorizationdetails.serviceDesc);

      }
      else {
      }
    }
    return errorMessages;

  }
  // validateExceedingAuthLimit(tempval, val, i): string[] {
  //   let errorMessages = [];
  //   let duplicateIds = {};
  //   let uniqueObjects = [];
  //   var authorization = this.authorizationdetails.filter(ad => ad.id == i.id)[0];
  //   this.selectedExceedingAuthList.push(authorization)
  //   this.selectedExceedingAuthList.forEach(function (obj) {
  //     if (!duplicateIds[obj.id]) {
  //       uniqueObjects.push(obj);
  //       duplicateIds[obj.id] = true;
  //     }
  //   });


  //   uniqueObjects.forEach(uniqueObjects => {
  //     if (uniqueObjects.authLimitType == "Weekly") {

  //       var StartDate = new Date(uniqueObjects.authLimitStartDate);
  //       let setDate = StartDate.setDate(StartDate.getDate() + 6);
  //       let getDate = setDate;
  //       let authLimitEndDate = this.datePipe.transform(getDate, "MM/dd/yyyy");
  //       if (uniqueObjects.startDate == uniqueObjects.authLimitStartDate && uniqueObjects.endDate == authLimitEndDate) {


  //       }
  //       else {

  //         errorMessages.push(uniqueObjects.masterServiceCode + uniqueObjects.serviceDesc);
  //       }

  //     }
  //   });
  //   return errorMessages;

  // }
  //.................................................ngOnDestroy........................................................
  public ngOnDestroy(): void {
    this.onDestroy$.next();
  }

 
}
